import styled, { css } from 'styled-components';
import { Container, MENU_HEIGHT, PageContent, StyledPrimaryButton, TableHeader } from './common';
import colors from './colors';

const SHARED_TITLE_STYLED = css`
  align-items: center;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;

  & > * {
    margin-right: 1em;
  }
`;

export const TITLE_HEIGHT = '22px';
export const TITLE_MARGIN = '32px';

export const SettingsPageContainer = styled(PageContent)`
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${colors.lightBackground}66;
`;

export const SettingsPageContent = styled(Container)<{ constraintToScreenHeight?: boolean }>`
  padding: 0px 0px 60px 16px;
  min-width: 800px;
  max-width: 1024px;
  flex-basis: 0;
  background-color: inherit;

  ${({ constraintToScreenHeight }) =>
    constraintToScreenHeight &&
    css`
      max-height: calc(100vh - ${MENU_HEIGHT} - (${TITLE_HEIGHT} + (${TITLE_MARGIN} * 2)));
    `}

  ${TableHeader} {
    ${StyledPrimaryButton} {
      height: 35px;
      min-width: 110px;
      font-size: 12px;
      margin-left: 20px;
    }
  }
`;
export const SettingsTitle = styled.h3`
  ${SHARED_TITLE_STYLED};
  margin: 13px 0 0;
  text-transform: uppercase;
`;

export const SettingsSubtitle = styled.h4`
  ${SHARED_TITLE_STYLED};
  margin-bottom: 0;
`;
